module.exports = __webpack_public_path__ + "img/9.66550d8a.jpg";